import { render } from "./CurrentRoundTable.vue?vue&type=template&id=6a2b2d9d"
import script from "./CurrentRoundTable.vue?vue&type=script&lang=js"
export * from "./CurrentRoundTable.vue?vue&type=script&lang=js"

import "./CurrentRoundTable.vue?vue&type=style&index=0&id=6a2b2d9d&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__